import { createSlice } from "@reduxjs/toolkit";

const promotionDeadlines = createSlice({
  name: "promotionDeadlines",
  initialState: {
    leadDeadline: "",
    functionalLeadDeadline: "",
    promotionBoardDeadline: "",
    isLeadDeadlinePast: false,
    isFunctionalLeadDeadlinePast: false,
    isPromotionBoardDeadlinePast: false,
  },
  reducers: {
    setIsLeadDeadlinePast: (state, action) => {
      state.isLeadDeadlinePast = action.payload;   
    },
    setIsFunctionalLeadDeadlinePast: (state, action) => {
      state.isFunctionalLeadDeadlinePast = action.payload;   
    },
    setIsPromotionBoardDeadlinePast: (state, action) => {
      state.isPromotionBoardDeadlinePast = action.payload;   
    },
    setLeadDeadline: (state, action) => {
      state.leadDeadline = action.payload;   
    },
    setFunctionalLeadDeadline: (state, action) => {
      state.functionalLeadDeadline = action.payload;   
    },
    setPromotionBoardDeadline: (state, action) => {
      state.promotionBoardDeadline = action.payload;   
    },
  },
});

export const { 
  setIsLeadDeadlinePast, 
  setIsFunctionalLeadDeadlinePast, 
  setIsPromotionBoardDeadlinePast, 
  setLeadDeadline, 
  setFunctionalLeadDeadline, 
  setPromotionBoardDeadline 
} = promotionDeadlines.actions;
export default promotionDeadlines.reducer;
